export default {
	Slide: 'Փազլ',
	Puzzle: 'Փազլ',
	'The puzzle is open!': 'Փազլը բաց է։',
	'Congratulations!': 'Շնորհավորում եմ:',
	'You get it': 'Դուք ստանում եք',
	'You get the task done': 'Դուք կատարում եք առաջադրանքը',

	'Show all blocked': 'Ցուցադրել բոլոր արգելափակվածները',

	Author: 'հեղինակ',
	'Reset filters': 'Վերականգնել զտիչները',

	Blocked: 'Արգելափակված',
	Unlocked: 'Ապակողպված է',

	Change: 'Փոփոխություն',
	'The student is blocked': 'Ուսանողն արգելափակված է',
	'The student is blocked with a new price': 'Ուսանողն արգելափակված է նոր գնով',
	'To unlock this student, go to the "Restore" section':
		'Այս ուսանողին ապակողպելու համար անցեք «Վերականգնում» բաժին',

	'Before blocking, you can change the price for the student':
		'Մինչ արգելափակելը, դուք կարող եք փոխել գինը ուսանողի համար',

	'Block student': 'Արգելափակել ուսանողին',

	'First month cost': 'Գինը 1 ամսվա համար',

	'WARNING! After re-saving the task, the students who completed this task will have the puzzle closed and will have to do it again.':
		'ԶԳՈՒՇԱՑՈՒՄ. Առաջադրանքը կրկին պահպանելուց հետո այս առաջադրանքը կատարած աշակերտների «փազլը» փակ կլինի, և պետք է նորից կատարեն այն:',

	"You cannot do homework in the student's platform":
		'Դուք չեք կարող տնային աշխատանք կատարել ուսանողի հարթակում',

	'Restore the student ?': 'Վերականգնե՞լ ուսանողին:',
	'Restore the teacher ?': 'Վերականգնե՞լ ուսուցչին:',
	'Restore the franchise ?': 'Վերականգնե՞լ արտոնությունը:',

	'Transition to 50': 'անցում դեպի 50',
	'Transition to 100': 'անցում դեպի 100',

	fifty: 'անցում դեպի 50',
	hundred: 'անցում դեպի 100',

	Faces: 'Դեմքեր',

	Heroes: 'Հերոսներ',
	Clothes: 'Հագուստ',
	Backgrounds: 'Նախապատմություններ',
	Souvenirs: 'Հուշանվերներ',

	'Coming soon': 'շուտով',

	'Wow! Congratulations, you have successfully purchased this product.':
		'Վա՜յ։ Շնորհավորում ենք, դուք հաջողությամբ ձեռք եք բերել այս ապրանքը:',
	'You can view all your purchases in the "Purchased" section':
		'Ձեր բոլոր գնումները կարող եք դիտել «Գնված» բաժնում',

	'Your savings': 'Ձեր խնայողությունները',
	'You can spend them on something interesting!':
		'Դուք կարող եք դրանք ծախսել ինչ-որ հետաքրքիր բանի վրա:',

	'A student with this email address already exists':
		'Նման էլփոստով օգտվող արդեն գոյություն ունի',

	'User with such email already exists':
		'Նման էլփոստով օգտվող արդեն գոյություն ունի',
	'Year of birth': 'Ծննդյան տարին',
	Registration: 'Գրանցում',
	'Surname of parents': 'Ծնողների ազգանունը',
	School: 'Դպրոց',
	'Field is required': 'Դաշտը պարտադիր է',
	'Select age': 'Ընտրեք տարիքը',
	'No such teacher for this year': 'Այս տարի նման ուսուցիչ չկա',
	'User with such phone number already exists':
		'Նման հեռախոսահամարով օգտվող արդեն գոյություն ունի',
	'You are successfully registered': 'Դուք հաջողությամբ գրանցված եք',
	'Max length 20 chars': 'Առավելագույն երկարությունը 20 chars',

	'INTERNATIONAL SCHOOL': 'ՄԻՋԱԶԳԱՅԻՆ ԴՊՐՈՑ',
	'Mental Arithmetic': 'Մենթալ թվաբանություն',
	'For children aged 5-14.': '5-14 տարեկան երեխաների համար.',
	'Sign up for a trial lesson': 'Գրանցվեք փորձնական դասի համար',
	'Parents name': 'Ծնողի անունը',
	'Childs age': 'Երեխայի տարիքը',
	Country: 'Երկիր',
	'Sign up': 'Գրանցվել',
	'Open offer agreement': 'Բաց առաջարկի պայմանագիր',

	'Participate in online Indigo Olympiad':
		'Մասնակցի՛ր «Indigo» առցանց օլիմպիադային',
	Participate: 'Մասնակցել',
	export: 'Արտահանում',
	wrong: 'Սխալ է',
	right: 'Ճիշտ է',
	match: {
		addition: 'Ֆորսաժ',
		multiply: 'Բազմապատկում',
		divide: 'Բաժանում',
		abacus_random: 'Շարժվող աբակուս',
		anzan: 'Անզան',
		negative: 'Բացասական թվեր',
		column: 'Սյունյակներ',
	},
	timeIsOver: 'Ժամանակը վերջացավ',
	timer: 'Erմչփ',
	'Back to Lessons': 'Վերադառնալ դասերին',
	'Create Lesson': 'Ստեղծել դաս',
	Assign: 'Նշանակել',
	Home: 'Գլխավոր',
	'To cabinet': 'Դեպի էջ',
	'Create a homework': 'Ստեղծեք տնային առաջադրանք',
	January: 'Հունվար',
	February: 'Փետրվար',
	March: 'Մարտ',
	April: 'Ապրիլ',
	May: 'Մայիս',
	June: 'Հունիս',
	July: 'Հուլիս',
	August: 'Օգոստոս',
	'Group nickname': 'Խմբի անվանում',
	September: 'Սեպտեմբեր',
	October: 'Հոկտեմբեր',
	November: 'Նոյեմբեր',
	December: 'Դեկտեմբեր',
	Overall: 'Ընդհանուր',
	Active: 'Ակտիվ',
	'Contract number': 'Պայմանագրի համարը',
	'For parents': 'Ծնողների համար',
	'Choose lessons': 'Ընտրել դասեր',
	Save: 'Նշանակել',
	Close: 'Փակել',
	'Change birthday': 'Փոխել ծննդյան ամսաթիվը',
	Sent: 'Ուղարկված է',
	'Choose date': 'Ընտրեք ամսաթիվ',
	'Include students': 'Ներառել սովորողներին',
	'Add service': 'Ավելացնել ծառայություն',
	'Create folder': 'Ստեղծել պանակ',
	Answer: 'Պատասխան',
	Price: 'Գինը',
	'Date of creating': 'Ստեղծման ամսաթիվը',
	Month: 'Ամիս',
	unpaid: 'Չվճարված',
	paid: 'Վճարված',
	'Excluded students': 'Արգելափակված սովորողներ',
	'Selected groups': 'Ընտրված խմբեր',
	Monday: 'Երկուշաբթի',
	Tuesday: 'Երեքշաբթի',
	Wensday: 'Չորեքշաբթի',
	Thusday: 'Հինգշաբթի',
	Friday: 'Ուրբաթ',
	Saturday: 'Շաբաթ',
	Sunday: 'Կիրակի',
	Mo: 'Երկ.',
	Tu: 'Երք.',
	We: 'Չրք.',
	Th: 'Հնգ.',
	Fr: 'Ուրբթ.',
	Sa: 'Շբթ.',
	Su: 'Կրկ.',
	End: 'Ավարտ',
	'Add discount': 'Ավելացնել զեղչ',
	Edit: 'Խմբագրել',
	'Parent found': 'Ծնողը նույնականացված է',
	'Changes saved': 'Փոփոխությունները պահպանված են',
	'The passwords of the parent and the student should not coincide':
		'Ծնողի և երեխայի գաղտնաբառերը չպետք է համընկնեն',
	'Your region`s price is set to': 'Ձեր տարածաշրջանի գինը սահմանված է ',
	'and the holder`s reward is': 'և սեփականատիրոջ պարգևն է ',
	'regardless of the set price': 'անկախ սահմանված գնից',
	'The given password is not unique for this email':
		'Տրված գաղտնաբառը վավեր չէ այս էլ.փոստի համար',
	'Enter a valid email address.': 'Մուտքագրեք վավեր էլ. փոստի հասցե',
	'The phone number entered is not valid':
		'Մուտքագրված հեռախոսահամարը վավեր չէ',
	Holiday: 'Արձակուրդ',
	'Working days': 'Աշխատանքային օրեր',
	Street: 'Փողոց',
	'Location name': 'Գտնվելու վայրը',
	District: 'Մարզ',
	'Mental arithmetic is an oral account technique that rapidly develops the intellectual ability and intelligence of a child between 5 and 14 years of age. The training process takes place on special Japanese accountants Abaсus (Soroban). Mental arithmetic trains simultaneously the left and right hemispheres of the brain, improving visual memory, concentration of attention, creative orientation, imaginative thinking of children and their tendency to fast reading.':
		'Մենթալ թվաբանությունը բանավոր հաշվարկի մեթոդիկա է , որը նպատակաուղղված կերպով զարգացնում է 5-14 տարեկան երեխաների մտավոր և ինտելեկտուալ ընդունակությունները: Ուսուցման գործընթացը իրականացվում է ճապոնական հատուկ Աբակուս, (Սորոբան) հաշվիչներով: Մենթալ թվաբանության մեթոդիկան միաժամանակ մարզում է գլխուղեղի երկու կիսագնդերը՝ զարգացնելով տեսողական հիշողությունը, ուշադրության կենտրոնացումը, ստեղծագործական մտածողությունը, վերացական մտածողությունը և արագ ընթերցանության կարողությունը:',

	'Field required': 'Պարտադիր դաշտ',
	'Type of legal activity': 'Իրավական գործունեության տեսակ',
	'Legal address': 'Իրավական հասցե',
	'Registration number': 'Գրանցման հասցե',
	'Add Group': 'Ավելացնել խումբ',
	'Add Student': 'Ավելացնել սովորող',
	Add: 'Ավելացնել',
	'Add file': 'Ավելացնել պանակ',
	Signin: 'Մուտք',
	'Bonus days': 'Բոնուսային օրեր',
	'Bonus weeks': 'Բոնուսային շաբաթներ',
	'Are you sure you want to delete?': 'Վստա՞հ եք, որ ցանկանում եք ջնջել',
	Delete: 'Ջնջել',
	Days: 'Օրեր',
	Confirm: 'Հաստատել',
	Cancel: 'Չեղարկել',
	Week: 'Շաբաթ',
	Weeks: 'Շաբաթներ',
	'Group age name': 'Խմբի տարիքային անվանում',
	'Set bonus days': 'Սահմանել բոնուսային օրեր',
	'Default language': 'Լեզուն ընտրել ինքնաբերաբար',
	'With english': 'Անգլերեն լեզվով',
	'Without english': 'Առանձ անգլերեն լեզվի',
	'Paid status': 'Վճարման կարգավիճակ',
	'Not paid': 'Վճարված չէ',
	Turnover: 'Շրջանառություն',
	Block: 'Արգելափակել',
	Blocked: 'Արգելափակված',
	'On holidays': 'Արձակուրդ',
	Language: 'Լեզու',
	Discounts: 'Զեղչեր',
	Message: 'Հաղորդագրություն',
	Subject: 'Թեմա',
	Homework: 'Տնային հանձնարարություն',
	'Homework ': 'Վարժանք',
	'Homework on': 'Տնային առաջադրանք',
	'You need to complete the exercises': 'Դուք ունեք կատարելու վարժություններ',
	Homework: 'Տնային հանձնարարություններ',
	'Invoice for': 'Վճարման հաշիվ',
	"PJSC CB 'PRIVATBANK' in Kyiv": 'PJSC CB  «PRIVATBANK» Կիեւում',
	Account: 'Հաշիվ',
	Supplier: 'Մատակարար',
	Buyer: 'Գնոդ',
	'Bank code': 'Բանկի կոդ ',
	'Type phone number or email':
		'Մուտքագրեք հեռախոսահամարը կամ էլ. փոստի հասցեն',
	'Type password': 'Մուտքագրեք ծածկագիրը',
	'Forgot password': 'Մոռացե՞լ եք գաղտնաբառը',
	'Type your email': 'Մուտքագրեք էլ.փոստի հասցեն',
	Send: 'Ուղարկել',
	'Email sent': 'Էլ. Նամակը ուղարկված է',
	'If you are signed up for the project you will receive email with the next instructions to get back access your account':
		'Եթե դուք գրանցվել եք համակարգում՝  Դուք  կստանաք հաջորդող հրահանգներով էլ. նամակ՝ ձեր հաշիվ մուտք գործելու համար',
	'Back to the sign in': 'Վերադառնալ կայքի մուտքին',
	'Password or login is not correct': 'Գաղտնաբառը կամ մուտքանունը սխալ է',
	'Password recovery': 'Գաղտնաբառի վերականգնում',
	'Type your new password here': 'Մուտքագրեք նոր գաղտնաբառ',
	'Set new password': 'Սահմանել նոր գաղտնաբառ',
	'Learn more': 'Իմանալ ավելին',
	'About Us': 'Մեր մասին',
	Company: 'Կազմակերպություն',
	Jobs: 'Աշխատանք',
	Press: 'Մամուլ',
	'Terms of Use': 'Օգտագործման պայմաններ',
	'Privacy Policy': 'Գաղտնիության քաղաքականություն',
	'Need help?': 'Օգնության կարիք ունե՞ք',
	'Contact us': 'Կապ մեզ հետ',
	'Become franchise': 'Ֆրանչայզինգ',
	'Select language': 'Ընտրել լեզուն',
	English: 'Անգլերեն',
	Russian: 'Ռուսերեն',
	Azerbaijani: 'Ադրբեջաներեն',
	Ukrainian: 'Ուկրաիներեն',
	Polish: 'Լեհերեն',
	Management: 'Կառավարում',
	'Master Franchise': 'Մաստեր-ֆրանչայզի',
	Franchise: 'Ֆրանչայզի',
	Teachers: 'ուսուցիչ',
	Groups: 'Խումբ',
	Students: 'Սովորողներ',
	Student: 'Սովորող',
	Parents: 'Ծնող',
	Profile: 'Անձնական էջ',
	'My profile': 'Իմ անձնական էջը',
	Finance: 'Ֆինանս',
	Reports: 'Հաշվետվություններ',
	Report: 'Հաշվետվություն',
	Upload: 'Վերբեռնել',
	List: 'Ցանկ',
	Payments: 'Վճարումներ',
	Documents: 'Փաստաթղթեր',
	Lessons: 'Դասեր',
	Materials: 'Ուսումնական նյութեր',
	Shop: 'Խանութ',
	Statistics: 'Վիճակագրություն',
	Settings: 'Կարգավորումներ',
	Pages: 'Էջեր',
	Logout: 'Դուրս գալ',
	Dashboard: 'Անձնական էջ',
	'Access denied': 'Մուտքը մերժվեց',
	Create: 'Գրանցել', //'Ստեղծել',
	New: 'Նոր',
	Download: 'Ներբեռնում',
	Status: 'Կարգավիճակ',
	'Payment Date': 'Վճարման ամսաթիվ',
	'Payment Amount': 'Վճարման գումար',
	'Start time': 'Դասընթացի մեկնարկի ամսաթիվը',
	'Group age': 'Տարիքային խումբ',
	Junior: 'Կրտսեր',
	Average: 'Միջին',
	Class: 'Դասարան',
	Older: 'Ավագ',
	Region: 'Մարզ',
	Group: 'Խումբ',
	Person: 'Անձ',
	Finances: 'Ֆինանս',
	Actions: 'Գործողություններ',
	'Send invoice': 'Ուղարկել հաշիվ ապրանքագիր',
	'Download invoice': ' Ներբեռնել հաշիվ ապրանքագիր',
	'Send email': 'Ուղարկել էլ. նամակ',
	'Send link': 'Ուղարկել հղում',
	Link: 'Հղում',
	'Create Student': 'Ավելացնել սովորող',
	'The beginning of holidays': 'Արձակուրդի սկիզբ',
	'Start of study': 'Դասընթացի սկիզբ',
	'Group name': 'Խմբի անվանում',
	'Group address': 'Խմբի հասցե',
	'Group teacher': 'Խմբի ուսուցիչ',
	'Group students': 'Խմբի սովորողներ',
	'Group statistics': 'Խմբի վիճակագրություն',
	Search: 'Փնտրել',
	'General information': 'Հիմնական տեղեկատվությունը',
	'Phone number': 'Հեռախոսահամար',
	'First name': 'Անուն',
	Surname: 'Հայրանուն',
	'Last name': 'Ազգանուն',
	'Date of birth': 'Ծննդյան ամսաթիվ',
	Password: 'Գաղտնաբառ',
	'Additional information': 'Լրացուցիչ տեղեկատվություն',
	'Id code': 'ID կոդ',
	Passport: 'Անձնագիր',
	'Without email newsletter': 'Առանց էլ. փոստի տեղեկագրի',
	'With email newsletter': 'Էլ.փոստի տեղեկագրով',
	'Financial information': 'Ֆինանսական տեղեկատվություն',
	Royalty: 'Հավատարմավճար',
	'PR contribution': 'PR ներդրում',
	Currency: 'Արժույթ',
	Comment: 'Մեկնաբանություն',
	Paid: 'Վճարված է',
	Invoices: 'Հաշիվապրանքագիր',
	Bills: 'Օրինագծեր',
	Acts: 'Ակտեր',
	Scan: 'Պատճեն',
	Level: 'Մակարդակ',
	'Action with numbers': 'Գործողություն թվերով',
	'Action with number': 'Գործողությունների քանակ',
	'Number of expressions': 'Գործողությունները քանակ',
	'Number of expression': 'Օրինակների քանակ Օրինակների քանակ',
	'Imaginary abacus': 'Երևակայական աբակուս',
	'Period report': 'Հաշվետու ժամանակաշրջան',
	City: 'Քաղաք',
	'Full name franchise': 'ֆչանչայզիի ԱԱՀ',
	'Students all//blocked/online ': 'Ակտիվ սովորողներ',
	'Сost of education': 'Դասընթացի արժեք',
	'Turnover franchise': 'Շրջանառություն',
	'Discount sum': 'Զեղչերի գումար',
	Proprietor: 'Հավատարմավճար',
	'Additional products and services': 'Լրացուցիչ ապրանքներ և ծառայություններ',
	'Full name student': 'Սովորողի ԱԱՀ',
	'Period of study': 'Ուսման ժամանակահատված',
	'Bonus-days': 'Բոնուսային օրեր',
	'Amount of days': 'Օրերի քանակ',
	'Total days': 'Ընդհանուր օրեր',
	'Language of instruction': 'Ուսուցման լեզու',
	Teacher: 'Ուսուցիչ',
	Discount: 'Զեղչ',
	Remuneration: 'Հավատարմավճար',
	Goods: 'Ապրանքներ',
	'Date of creation': 'Ստեղծման ամսաթիվ',
	'Date of payment': 'Վճարման ամսաթիվ',
	'Goods (works, services)': 'Ապրանքներ (աշխատանքներ, ծառայություններ)',
	Quantity: 'Քանակ',
	Units: 'Միանիշներ',
	Amount: 'Ընդհանուր',
	Sum: 'Գումար',
	'Sum Sub': 'Ֆորսաժ',
	Financial: 'Ֆինանսական',
	Additional: 'Լրացուցիչ',
	General: 'Ընդհանուր',
	Total: 'Ընդամենը',
	Save: 'Պահպանել',
	'Including with': 'Այդ թվում նաև',
	'Training materials': 'Դասընթացի նյութեր',
	'Learning contract': 'Պայմանագիր',
	Games: 'Խաղեր',
	'NUMBER OF 11 TO 120': '11-ից 120-ի ՀԱՄԱՐ',
	Complexity: 'Բարդություն',
	Start: 'Մեկնարկ',
	'Speedy numbers': 'Գումարում և հանում',
	Anzan: 'Անզան',
	'Abacus is random': 'Շարժվող աբակուս',
	Multiplication: 'Բազմապատկում',
	Division: 'Բաժանում',
	Abacus: 'Աբակուս',
	'Abacus Random': 'Աբակուս պատահական',
	'Multiplying by 20': 'Բազմապատկում 20-ի սահմանում',
	Squared: 'Քառակուսի բարձրացնել',
	'Division to 20': 'Բաժանում 20-ի սահմանում',
	Speed: 'Արագություն',
	Repeat: 'Կրկնություն',
	'Game type': 'Վարժության տեսակ',
	'Digit type': 'Թիվ',
	Digit: 'Թիվ',
	Time: 'Ժամանակ',
	Oral: 'Երևակայական հաշիվ',
	Second: 'Վարկյան',
	'Calculation method': 'Համրանքի ձև',
	'Only negative numbers starting with 99,999,9999 etc., depending on the complexity of the expression: -9, -2, -3, -1 ...':
		'Միայն բացասական թվերը, սկսած 99,999,9999 և այլն, կախված արտահայտության բարդությունից ՝ -9, -2, -3, -1 ...',
	'Only subtraction': 'Միայն հանում',
	'Only positive numbers starting with 0. Expression: +1, +4, +6, +9, +5 ...':
		'Միայն դրական թվերը, սկսած 0.-ից: Արտահայտությունը ՝ +1, +4, +6, +9, +5 ...',
	'Only add': 'Միայն գումարում',
	'Numbers fall randomly, starting with 0. Expression :: +3, -5, -1, +9, -2 ...':
		'Պատահական թվեր ՝ սկսած 0-ից. Արտահայտությունը :: +3, -5, -1, +9, -2 ...',
	'Random numbers': 'Պատահական թվեր',
	'CHOOSE COMPLEXITY:': 'Ընտրեք բարդության մակարդակը',
	'AMOUNT OF ACTIONS WITH NUMBER': 'ԹՎԱՅԻՆ ԳՈՐԾՈՂՈՒԹՅՈՒՆՆԵՐԻ ՔԱՆԱԿ',
	FAMILY: 'ԸՆՏԱՆԻՔ',
	'BIG FRIENDS': 'ՄԵԾ ԸՆԿԵՐՆԵՐ',
	'LITTLE FRIENDS': 'ՓՈՔՐ ԸՆԿԵՐՆԵՐ',
	'JUST FRIENDS': 'ՈՒՂՂԱԿԻ ԸՆԿԵՐՆԵՐ',
	'big friends': 'մեծ ընկերներ',
	'small friends': 'փոքր ընկերներ',
	elementary: 'ուղղակի ընկերներ',
	family: 'ընտանիք',
	Sound: 'Ձայն',
	'Congratulations! You did it! Now you can go to the following exercises':
		'Կեցցե՛ս, դու կատարեցիր վարժությունը: Այժմ կարող ես կատարել հաջորդը:',
	'RIGHT. ANSWER:': 'ՃԻՇՏ Է: ՊԱՏԱՍԽԱՆ',
	CORRECT: 'ՊԱՏԱՍԽԱՆԸ ՃԻՇՏ Է',
	'NOT CORRECT': 'ՊԱՏԱՍԽԱՆԸ ՍԽԱԼ Է',
	'Try again': 'Փորձի՛ր կրկին', //'Փորձիր ևս մեկ անգամ',
	expression: 'Արտահայտություն',
	next: 'Հաջորդ',
	Next: 'Հաջորդը',
	Previous: 'Նախորդ',
	Loading: 'Բեռնվում է',
	back: 'հետ քայլ',
	Back: 'Հետ քայլ',
	ANSWER: 'Պատասխան',
	Lesson: 'Դաս',
	'History statistics': 'Վիճակագրության պատմություն',
	Open: 'Բացել',
	'Game statistics per day': 'Օրվա կատարված վարժությունների վիճակագրություն',
	'Total played games': 'Կատարված վարժությունների ընդհանուր քանակ',
	'Total correct answers': 'Ճիշտ պատասխանների ընդհանուր քանակ',
	'Total played:': 'Ընդհանուր կատարված վարժությունների քանակ',
	Feedback: 'Հետադարձ կապ',
	'Leave a review': 'Ուղարկել կարծիք',
	'Leave us your feedback or wishes and we will definitely consider them in our work.':
		'Ուղարկեք մեզ Ձեր կարծիքը, մենք այն անպայման հաշվի կառնենք մեր հետագա աշխատանքում',
	'Payment history': 'Վճարման պատմություն',
	'Payment status': 'Վճարման կարգավիճակ',
	Pay: 'Վճարել',
	Payer: 'Հաճախորդ',
	'Getting a discount': 'Ստանալ զեղչ',
	Training: 'Վարժանք',
	Tasks: 'Առաջադրանք',
	'Current task': 'Ընթացիկ հանձնարարություն',
	'Only task': 'Առաջադրանք',
	'Next tasks': 'Հաճորդ առաջադրանք',
	'Online abacus': 'Առցանց ապակուս',
	'Base 50/100': 'Սահման 50/100',
	multiply_base: 'Սահման 50/100',
	divided: 'Բաժանելի',
	'Do not show this instruction again': 'Այլևս չցուցադրել',
	'Instructions for homework': 'Տնային հանձնարարության կատարման ցուցումներ',
	divider: 'բաժանարար',
	'Multiplication table': 'Բազմապատկման աղյուսակ',
	Restore: 'Վերականգնել',
	'left/done': 'մնացել է/կատարված է',
	'Restore Hierarchy': 'Վերականգնել աստիճանակարգումը',
	active: 'ակտիվ',
	blocked: 'Արգելափակված',

	pageError: {
		'403': 'Մուտքը արգելափակված է',
		'404': 'Этой страницы не существует. Попробуйте заново.',
		'500': ' Համակարգի սխալ, կրկին փորձեք',
	},
	error: {
		'Account deactivated': 'Ձեր էջը արգելափակված է',
	},
	modalNewVersion: {
		text:
			'Դուք օգտագործում եք կայքի հնացած տարբերակը.\nԹարմացումները արդեն հասանելի են:',
		btn: 'Խաղեր',
	},
	games: {
		negativeNumbers: 'Բացասական թվեր',
		columns: {
			name: 'Սյունյակներ',
			users: 'Մասնակիցների քանակ',
			user: 'Մասնակից',
			userNames: 'Մասնակիցների անուններ',
		},
	},
	'Indigo-dollars': 'Indigo-դոլլարներ',
	Balance: 'հաշվեկշիռ',

	modalIndigoDollars: {
		submit: 'Ուղարկել',
		cancel: 'Չեղարկել',
		title: 'Indigo -դոլլարներ',
		balance: 'Ընթացիկ հաշվեկշիռ',
		amount: 'Քանակ',
		reason: 'Մեկնաբանություն',
	},

	modalAddNotification: {
		title: 'Ավելացնել ծանուցում',
		submit: 'Ուղարկել',
		cancel: 'Չեղարկել',
		empty: 'Ծանուցում առկա չէ',
	},

	modalTransactionsHistory: {
		title: 'Վճարումներ պատմություն',
		type: {
			withdraw: 'Նկարագրություն',
			deposit: 'Համալրում',
		},
		empty: 'Վճարումների պատմությունը դատարկ է',
	},

	modalCopyHomework: {
		title: 'Տնային հանձնարարության կրկնօրինակում',
		label:
			'Ընտրեք ամսաթիվը, որի վրա անհրաժեշտ է կրկնօրինակել տնային հանձնարարությունը',
		submit: 'Կրկնօրինակել',
		cancel: 'Չեղարկել',
	},

	reportsPage: {
		history: {
			title: 'Փոփոխությունների պատմություն',
			empty: 'Ցուցակը դատարկ է',
			table: {
				date: 'Փոփոխության ամսաթիվ',
				field_name: 'Գործողություն',
				old_value: 'Հին նշանակություն',
				new_value: 'Նոր նշանակություն',
				user: 'Փոփոխված է օգտատիրոջ մոտ',
			},
		},
	},

	pageShop: {
		title: 'Խանութ',
		description:
			'Խանութում կարող եք ձեռք բերել տարատեսակ ապրանքներ՝ Ձեր անձնական էջի արտաքին տեսքը գեղեցկացնելու համար:',

		tabs: {
			all: 'Բոլոր ապրանքները',
			purchased: 'Գնված',
		},

		item: {
			off_all: 'Փակել բոլորը',

			status: {
				AVAILABLE: 'Խորհուրդ է տրվում',
				DEPRECATED: 'Անհասանելի է',
				COMING_SOON: 'Շուտով հասանելի կլինի',
			},
			is_activated: 'Ընտրված է',
			set_active: 'Ընտրել',
			unset_active: 'Անջատել',
			preview: 'Նախապես դիտել',
			is_free: 'Անվճար',
			buy: 'Գնել',
			bought: 'Գնված է',
			purchased: 'Գնված է',
		},
		empty: {
			all: 'Հասանելի բարելավում առկա չէ',
			purchased: 'Ձեռք բերված բարելավում առկա չէ',
		},

		toast: {
			error: 'Տեղի է ունեցել սխալ',
			notEnoughMoney: 'Անբավարար միջոցներ',
			itemBought: 'Բարելավումը ձեռք է բերված',
			itemActivated: 'Բարելավումը ակտիվացված է',
			itemDeactivated: 'Բարելավումը ակտիվացված է է',
		},
		confirmPurchase: {
			title: 'Հաստատել գնումը',
			message: 'Վստահեզ եք որ ցանկանում եք գնել այս ապրանքը։',
			confirm: 'Այո գնել',
			cancel: 'Չեղարկել',
		},
	},

	demo: {
		title: 'Անվճար դեմո դաս',
		tutorial: {
			title: 'Օգտագործման հրահանգ',
			text: 'Գործողության նկարագրություն',
		},
	},
}
